import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../../../Common/Toggle/Toggle';

export const ConfigurationSection = (props) => {
    const onActiveChange = (name, isChecked) => {
        props.onFormChange(name, isChecked);
    }

    const className = props.isFormValid ? "configuration-form" : "configuration-form was-validated"
    return (
        <div className="configuration-section section">
            <form className={className} noValidate>
                <div className="row content">
                    <div className="col-12 col-md-4 header">
                        <h4>Configuration</h4>
                        <p>Customize the look and feel of Pacer for your teams.</p>
                    </div>
                    <div className="col-12 col-md-8 fields">
                        <div className="row">                           
                            <div className="col-12 col-lg-6">
                                <Toggle name="isStartDateActive" text="Display Start Date on tasks" checked={props.subscription.isStartDateActive} onChange={onActiveChange} />
                            </div>
                            <div className="col-12 col-lg-6">
                                <Toggle name="isTaskDependenciesActive" text="Display Pre-Requisites on tasks" checked={props.subscription.isTaskDependenciesActive} onChange={onActiveChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <Toggle name="isTaskStepsActive" text="Display Tasks Steps on tasks" checked={props.subscription.isTaskStepsActive} onChange={onActiveChange} />
                            </div>
                            <div className="col-12 col-lg-6">
                                <Toggle name="isTaskEffortActive" text="Display Effort on tasks" checked={props.subscription.isTaskEffortActive} onChange={onActiveChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <Toggle name="isTaskFinancialsActive" text="Display Budget and Actual on tasks and Dashboard" checked={props.subscription.isTaskFinancialsActive} onChange={onActiveChange} />
                            </div>
                            <div className="col-12 col-lg-6">
                                <Toggle name="isSSOEnabled" text="Single Sign On (SSO) Enabled" checked={props.subscription.isSSOEnabled} isDisabled />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6">
                            {props.subscription.isProjectWidgetActive &&
                                <Toggle name="isProjectIdRequiredForLocationTask" text="Require Project selection for all tasks" checked={props.subscription.isProjectIdRequiredForLocationTask} onChange={onActiveChange} />                    
                            }
                            </div>
                            <div className="col-12 col-lg-6">
                                <Toggle name="isTaskCompressionForOwnerEnabled" text="Allow task compression utility for Owner Role" checked={props.subscription.isTaskCompressionForOwnerEnabled} isDisabled />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                &nbsp;
                            </div>
                            <div className="col-12 col-lg-6">
                                <Toggle name="isTaskCompressionForAdminEnabled"
                                    text="Allow task compression utility for Admin Role" 
                                    checked={props.subscription.isTaskCompressionForAdminEnabled} 
                                    onChange={onActiveChange}
                                    isDisabled={!props.subscription.isTaskCompressionForOwnerEnabled} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

ConfigurationSection.propTypes = {
    subscription: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    onFormChange: PropTypes.func.isRequired,
};

export default ConfigurationSection;

